/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum BenefitDocumentType {
  SELF_REPORT = 'SELF_REPORT',
  APPLICATION = 'APPLICATION',
  ENROLLMENT = 'ENROLLMENT',
  WAIVE = 'WAIVE',
  CONFIRMATION = 'CONFIRMATION',
  QLE = 'QLE',
  ELECTION_CONSENT = 'ELECTION_CONSENT',
  APPLICATION_CONSENT = 'APPLICATION_CONSENT',
  SHOPPING_UPLOAD = 'SHOPPING_UPLOAD',
  OTHER = 'OTHER',
}
